var $body,
  $toggleFilter,
  $filter,
  $searchFilter,
  $searchLocation,
  $headerSearch,
  $headerSearchToggle,
$sf;

$(document).ready(function($) {
  $body          = $('body');
  $toggleFilter       = $('.js-filter-toggle');
  $filter             = $('.js-filter');
  $searchFilter       = $('.searchandfilter');
  $sf                  = $searchFilter[0];// Single instance search filter
  $searchLocation     = $('.c-course-grid__container .c-location-filter__input'); // Multiple search forms
  $headerSearch       = $('.js-header-search');
  $headerSearchToggle = $('.js-header-search-toggle');
  // $headerRedirect     = $('.js-search-redirect'); //input
  // $headerRedirectBtn  = $('.js-geo-search-redirect'); //submit

  // Toggle filter on mobile
  $toggleFilter.on('click', function(e) {
    $filter.toggleClass('is-open');
    $(this).parent().toggleClass('is-open');
  });

  $('.js-search-form').on('submit', function(e){

    e.preventDefault();

    var arr = $(this).serializeArray()
    var NewParameters = [];

    $(arr).each(function(){
      var item = $(this)[0];

      if (item.name === 'plaats' && item.value !== 'none' && item.value) {
        NewParameters.push(item);
      } else if (item.name === '_sft_event-level' && item.value !== 'none' && item.value) {
        NewParameters.push(item);
      }
    });

    window.location = this.action + '?' + $.param( NewParameters );
  });

  $('.js-geo-search-action').click(function() {
    console.log('submit');
    $sf.submitForm();
  });

// set up a listener
  $searchLocation.on('change', function() {
    $sf.addQueryParam('plaats', $(this).val(), 'all');
  });

// on load
  if ($searchLocation.val()) {
    $sf.addQueryParam('plaats', $searchLocation.val(), 'all');
  }

  $searchLocation.on('keypress',function(e) {
    if(e.which === 13) {
      console.log('submit 2');
      $sf.submitForm();
    }
  });

  $headerSearchToggle.on('click', function () {
    $headerSearch.toggleClass('is-open');

    if ($headerSearch.hasClass('is-open')) {
      $headerSearch.find('input').focus();
    }
  });
  //
  // $headerRedirect.on('keypress',function(e) {
  //   if(e.which === 13) {
  //     var search = $(this).val();
  //     var url = $(this).data('redirect');
  //
  //     window.location.href = url + '?plaats=' + search;
  //   }
  // });
  //
  // $headerRedirectBtn.on('click', function(e){
  //   var search = $(this).prev().val();
  //   var url = $(this).prev().data('redirect');
  //
  //   window.location.href = url + '?plaats=' + search;
  // })
});
